import UgcStepsView from "./StepsView";

export default UgcStepsView;
